"use client"

import React, { createContext, useContext } from 'react'

type ReadOnlyContextType = {
  isReadOnly: boolean
  canEditProjectNotes: boolean
  /** Volunteers, Supporters, and Partners cannot toggle Goodwill toggles on Home Details. */
  canEditGoodwill: boolean
}

const ReadOnlyContext = createContext<ReadOnlyContextType | null>(null)

export function ReadOnlyProvider({
  children,
  isReadOnly,
  canEditProjectNotes,
  canEditGoodwill = true,
}: {
  children: React.ReactNode
  isReadOnly: boolean
  canEditProjectNotes: boolean
  canEditGoodwill?: boolean
}) {
  return (
    <ReadOnlyContext.Provider value={{ isReadOnly, canEditProjectNotes, canEditGoodwill }}>
      {children}
    </ReadOnlyContext.Provider>
  )
}

export function useReadOnly(): ReadOnlyContextType {
  const context = useContext(ReadOnlyContext)
  // Return default values if context is not available (for forms outside home details)
  return context || { isReadOnly: false, canEditProjectNotes: false, canEditGoodwill: true }
}

